import styled from '@emotion/styled';
import { css } from '@emotion/core';

export const TooltipWrapper = styled.div`
  position: absolute;
  pointer-events: none;
  z-index: 8999999;
  display: none;
  width: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-style: solid;
  border-width: 0;
  border-left-width: 4px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(3px);
  margin: 0;
  max-width: 320px;
  opacity: 1;
  transition: opacity 100ms 100ms linear;

  ${({ isFixedOnMobile, theme }) =>
    isFixedOnMobile &&
    `
    ${theme.breakpoints.sm.down} {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100vw;
      max-width: none;
      border-radius: 4px 4px 0 0;
    }
  `}

  ${({ isVisible }) =>
    isVisible &&
    `
    display: inline-block;
  `}

  ${({ tooltipIsVisible }) =>
    tooltipIsVisible &&
    `
    opacity: 0;
  `}

  ${({ isInverted, theme }) =>
    isInverted &&
    `
    ${theme.breakpoints.sm.up} {
      transform: translate3d(-100%, 0, 0);
      margin-left: -20px;
    }
  `}
`;

export const TooltipHeader = styled.header`
  padding: 12px 12px 8px;

  ${({ minimizeSize, theme }) =>
    minimizeSize &&
    `
    ${theme.breakpoints.sm.down} {
      padding: 8px 8px 6px;
    }
  `}
`;

export const tooltipClose = css`
  position: absolute;
  right: 12px;
  pointer-events: all;
`;

export const TooltipTitle = styled.h5`
  font-weight: 700;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 2px;
  font-size: 13px;

  ${({ minimizeSize, theme }) =>
    minimizeSize &&
    `
    ${theme.breakpoints.sm.down} {
      font-size: 11px;
    }
  `}
`;

export const TooltipSubtitle = styled.h6`
  color: ${({ theme }) => theme.colors.grey40};
  font-weight: 400;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 4px;
  font-size: 12px;

  ${({ minimizeSize, theme }) =>
    minimizeSize &&
    `
    ${theme.breakpoints.sm.down} {
      font-size: 10px;
    }
  `}
`;

export const TooltipBody = styled.div`
  background: rgba(0, 0, 0, 0.03);
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  padding: 8px 12px 12px;

  ${({ minimizeSize, theme }) =>
    minimizeSize &&
    `
    ${theme.breakpoints.sm.down} {
      padding: 6px 8px;
    }
  `}
`;

export const TooltipIcon = styled.div`
  padding: 0 10px;
  font-size: 4rem;
  font-size: ${({ theme }) => theme.colors.grey40};
`;

export const TooltipLabel = styled.div`
  color: ${({ theme }) => theme.colors.grey40};
  line-height: 1.3;
  flex-basis: 100%;
  margin-bottom: 4px;
  font-size: 12px;

  ${({ minimizeSize, theme }) =>
    minimizeSize &&
    `
    ${theme.breakpoints.sm.down} {
      font-size: 10px;
  `}
`;

export const TooltipUnit = styled.div`
  font-weight: 400;
  line-height: 1.2;
  margin-bottom: 3px;
  flex-grow: 1;
  max-width: 160px;
  font-size: 13px;

  ${({ minimizeSize, theme }) =>
    minimizeSize &&
    `
    ${theme.breakpoints.sm.down} {
      font-size: 11px;
      margin-bottom: 1px;
    }
  `}
`;

export const TooltipValue = styled.div`
  font-weight: 700;
  line-height: 1.1;
  margin-right: 10px;
  flex-grow: 0;
  font-size: 36px;

  ${({ minimizeSize, theme }) =>
    minimizeSize &&
    `
    ${theme.breakpoints.sm.down} {
      font-size: 20px;
      margin-right: 4px; 
      font-weight: 900;
    }
  `}

  ${({ theme }) => theme.breakpoints.lg.up} {
    font-size: 40px;
  }

  ${({ theme }) => theme.breakpoints.xl.up} {
    font-size: 44px;
  }
`;
